import { render, staticRenderFns } from "./ReportChart.vue?vue&type=template&id=15da0c50"
import script from "./ReportChart.vue?vue&type=script&lang=js"
export * from "./ReportChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports